import { casinoProviderStore } from '~/stores/casino-provider'
export function useCasinoProvider() {
  const { setCasinoProvider, getCasinoProvider, resetCasinoProvider } =
    casinoProviderStore()

  const casinoProviders = computed(() => {
    return getCasinoProvider()
  })
  return {
    casinoProviders,
    setCasinoProvider,
    getCasinoProvider,
    resetCasinoProvider,
  }
}
